import { useQuery } from "@tanstack/react-query";
import { SUBSCRIPTION_REQUEST_QUERY_KEYS } from "../configs/queryKeys";
import { SubscriptionRequestService } from "../services/subscriptionRequest.service";

export const useActivePromotionsQuery = (organizationId: string | null | undefined) =>
  useQuery({
    queryKey: organizationId
      ? SUBSCRIPTION_REQUEST_QUERY_KEYS.activePromotions(organizationId)
      : ["active-promotions", "disabled"],
    queryFn: () => SubscriptionRequestService.getActivePromotions(organizationId as string),
    enabled: Boolean(organizationId),
    staleTime: 60_000,
  });
